/** @jsx jsx */
import { Box, jsx } from "theme-ui";
import React, { CSSProperties } from "react";
import { ContentfulNavItem } from "../../../graphql-types";
import { NavItem } from "./nav-item";
import { StyleProps } from "../../types/types";

export type NavProps = {
  navItems: ContentfulNavItem[];
  level?: number;
  visible?: boolean;
  variant?: string;
} & StyleProps;
export const Nav: React.FC<NavProps> = ({
  navItems,
  level = 0,
  visible = true,
  children,
  variant = "main",
}) => {
  const isTopLevel = level === 0;

  //list layout
  let listDirection: CSSProperties["flexDirection"][] = ["row"];
  let listPosition: CSSProperties["position"][] = ["relative"];
  let top = ["0px"];
  if (isTopLevel) {
    if (variant === "main") {
      listDirection = ["column", "row"];
      listPosition = ["absolute", "relative"];
      top = ["70px", "0px"];
    }
    if (variant === "shop") {
      top = ["0px", "0px"];
    }
  }
  if (!isTopLevel) {
    listDirection = ["column"];
  }

  return (
    <Box
      as="ul"
      sx={{
        position: listPosition,
        bg: [isTopLevel ? "primary" : "primaryLight", "transparent"],
        zIndex: variant === "main" ? "101" : "100",
        "::-webkit-scrollbar": {
          display: "none",
        },
        left: "0px",
        top: top,

        width: "100%",
        display: visible ? "flex" : "none",
        flexDirection: listDirection,

        justifyContent: isTopLevel ? ["space-between"] : ["flex-start"],
        alignItems: isTopLevel ? ["center"] : ["flex-start"],

        overflowX: variant === "main" ? "inherit" : ["auto"],
        whiteSpace: "nowrap",

        flexWrap: "nowrap",
      }}
    >
      {navItems?.map((item) => (
        <NavItem
          key={item.label}
          variant={`nav.${variant}`}
          item={item}
          isTopLevel={isTopLevel}
          level={level}
        />
      ))}
      {children}
    </Box>
  );
};

export default Nav;
